import { Pipe, PipeTransform, inject } from '@angular/core';
import { AdminBrandStatus } from '@web/shared/module/brand';
import { Observable } from 'rxjs';
import { Nillable } from '@web/utils';
import { AdminBrandStatusProviderService } from '../providers/admin-brand-status-provider.service';

@Pipe({
  name: 'adminBrandStatus',
  standalone: true,
})
export class AdminBrandStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminBrandStatusProviderService);

  public transform(status: AdminBrandStatus): Observable<Nillable<string>> {
    return this.provider.labelFor(status);
  }
}
